export { default } from './TwoUpGrid';
